// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/online-payment-transaction-processing-schema',
  type: 'object',
  required: [],
  properties: {
    transactionId: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
